const styleTable = {
  borderCollapse: 'collapse',
  borderRadius: '5px',
  fontSize: '13px',
  fontWeight: '500',
  borderColor: '#0000002e',
  minWidth: '800px'
};

const tableHover = {
  '& tr:nth-child(even)': {
    backgroundColor: '#f2f2f2'
  }
};

const bgPurple = {
  backgroundColor: '#9a00afcf',
  textAlign: 'center',
  color: 'white'
};

const bgEmerald = {
  backgroundColor: '#009688',
  textAlign: 'center',
  color: 'white'
};

const bgYellow = {
  backgroundColor: '#ffff6d',
  textAlign: 'center',
  color: 'black'
};

const bgMarino = {
  backgroundColor: '#2F75B5',
  textAlign: 'center',
  color: 'white'
};

const bgOrange = {
  backgroundColor: '#FFC107',
  textAlign: 'center',
  verticalAlign: 'middle'
};

const deppOrange = {
  backgroundColor: '#FF5722',
  textAlign: 'center',
  color: 'white'
};

const bgSkyBlue = {
  backgroundColor: '#5B9BD5',
  textAlign: 'center',
  color: 'white'
};

const bgPlomo = {
  backgroundColor: '#D9D9D9',
  textAlign: 'center',
  color: 'black'
};

const bgFooter = {
  backgroundColor: '#6deb72',
  textAlign: 'right'
};

const bgTotal = {
  backgroundColor: '#ED7D31',
  textAlign: 'right',
  color: 'white'
};

const bgBlue = {
  backgroundColor: '#16718d',
  textAlign: 'center',
  color: 'white'
};

const bgDarkGreen = {
  backgroundColor: '#32d1a5',
  textAlign: 'center'
};

const bgBlack = {
  backgroundColor: 'black',
  textAlign: 'center',
  color: 'white'
};

const bgCobert = {
  backgroundColor: '#3F51B5',
  textAlign: 'center',
  color: 'white'
};

const bgAqua = {
  backgroundColor: '#82e2e7',
  textAlign: 'center'
  /* color: 'white' */
};

export {
  styleTable,
  tableHover,
  bgPurple,
  bgEmerald,
  bgYellow,
  bgMarino,
  bgOrange,
  bgSkyBlue,
  bgPlomo,
  bgFooter,
  bgTotal,
  bgBlue,
  bgDarkGreen,
  bgBlack,
  bgCobert,
  bgAqua,
  deppOrange
};
